import React from 'react';
import PropTypes from 'prop-types';

const MenuHeader = ({ closeMenu }) => (
  <div className="menu__header">
    <div className="menu-header">
      <h2 className="menu-header__title">Menu</h2>
      <button className="menu-header__close-btn" onClick={closeMenu}>
        &times;
      </button>
    </div>
  </div>
);

MenuHeader.propTypes = {
  closeMenu: PropTypes.func,
};

export default MenuHeader;
